/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */


let additional = 1;

const cloneUpdateAndInsert = (el, before) => {
  const newEl = el.clone();
  newEl.attr('id', newEl.attr('id').replace(/0/g, additional));
  newEl.html(newEl.html().replace(/0/g, additional));
  newEl.insertBefore(before);
};

$('#add-child').on('click', function () {
  additional += 1;
  cloneUpdateAndInsert($('#Form_RegistrationForm_ChildFirstName0ChildMiddleNames0ChildSurname0ChildGender0ChildDateOfBirth0ChildWhangai0_Holder'), this);
});



$("#Form_RegistrationForm_SameAsPostal").on("click", function () {
  const checked = $(this).is(":checked");
  if (checked) {
    $("#Form_RegistrationForm_StreetNo").val("");
    $("#Form_RegistrationForm_StreetName").val("");
    $("#Form_RegistrationForm_Suburb").val("");
    $("#Form_RegistrationForm_City").val("");
    $("#Form_RegistrationForm_PostCode").val("");
    $("#Form_RegistrationForm_Country").val("");
  }
  $("#Form_RegistrationForm_StreetNo").prop("disabled", checked);
  $("#Form_RegistrationForm_StreetName").prop("disabled", checked);
  $("#Form_RegistrationForm_Suburb").prop("disabled", checked);
  $("#Form_RegistrationForm_City").prop("disabled", checked);
  $("#Form_RegistrationForm_PostCode").prop("disabled", checked);
  $("#Form_RegistrationForm_Country").prop("disabled", checked);
});

